<template>
  <CBox
    :bg="['none', 'var(--colors-light-primary-light-gray)']"
    :minHeight="['auto', 'calc(100vh - 80px)']"
    width="100vw"
    position="sticky"
    pt="10px"
  >
    <OmtGrid pt="40px">
      <OmtRow>
        <OmtTypography as="h1-bold" mb="40px">Protocolo {{ protocol }}</OmtTypography>
      </OmtRow>

      <OmtRow>
        <div class="info-grid">
          <TextTile :title="'Assunto'" :description="assunto" />
          <TextTile :title="'Data da solicitação'" :description="dataSolicitacao" />
          <TextTile :title="'Beneficiário'" :description="beneficiario" />
          <TextTile v-if="!isMobile" :title="'Código do associado'" :description="codigoBeneficiario" />
          <div>
            <OmtTypography as="p2" color="var(--colors-light-primary-gray2)"> Status </OmtTypography>
            <StatusTile :label="statusLabel" :color="statusColor" />
          </div>
        </div>
      </OmtRow>

      <OmtRow
        v-if="isAnalyzingStatus"
        mt="32px"
        :desktopEnd="12"
        border="0.5px solid var(--colors-light-secondary-divider)"
        border-radius="8px"
        py="19px"
        px="16px"
      >
        <CBox>
          <CFlex align="center" justify="space-between" mb="16px">
            <CFlex align="center">
              <CBox
                bg="#1CA0FF"
                border-radius="50%"
                w="24px"
                h="24px"
                display="flex"
                align-items="center"
                justify-content="center"
                mr="12px"
              >
                <OmtIcons name="user" size="1x" color="#ffffff" />
              </CBox>
              <OmtTypography as="h2-bold"> Sua solicitação </OmtTypography>
            </CFlex>
            <OmtTypography as="p2" color="var(--colors-light-primary-gray2)">
              {{ dataSolicitacao }}
            </OmtTypography>
          </CFlex>

          <OmtTypography as="p1" color="var(--colors-light-primary-gray2)" ml="36px">
            {{ requestDescription }}
          </OmtTypography>

          <CGrid v-if="pictures.length" class="image-grid" mt="12px" ml="36px">
            <ImagePreviewer
              v-for="(picture, index) in pictures"
              :key="'img-' + index"
              v-bind="picture"
              :source="picture.source || picture"
              style="width: 32px; height: 32px; border-radius: 4px; object-fit: contain"
            />
          </CGrid>
        </CBox>
      </OmtRow>

      <OmtRow
        v-else-if="statusCode === 'F'"
        mt="32px"
        :desktopEnd="12"
        border="0.5px solid var(--colors-light-secondary-divider)"
        border-radius="8px"
        py="19px"
        px="16px"
        class="timeline-block"
      >
        <div class="timeline-container">
          <div class="timeline-item">
            <CBox class="timeline-icon" bg="#1CA0FF">
              <OmtIcons name="user" size="1x" color="white" />
            </CBox>

            <div class="timeline-content">
              <CFlex align="center" justify="space-between" mb="4px">
                <OmtTypography as="h2-bold">Sua solicitação</OmtTypography>
                <OmtTypography as="p2" color="var(--colors-light-primary-gray2)">
                  {{ dataSolicitacao }}
                </OmtTypography>
              </CFlex>

              <OmtTypography as="p1" color="var(--colors-light-primary-gray2)" mt="8px">
                {{ requestDescription }}
              </OmtTypography>

              <CGrid v-if="pictures.length" class="image-grid" mt="12px">
                <ImagePreviewer
                  v-for="(picture, index) in pictures"
                  :key="'img-final-' + index"
                  v-bind="picture"
                  :source="picture.source || picture"
                />
              </CGrid>
            </div>
          </div>

          <div v-for="(r, idx) in hasResponse" :key="'resp-' + idx" class="timeline-item">
            <CBox class="timeline-icon" bg="#0052CC">
              <img :src="IconOmint" style="width: 16px; height: 16px" />
            </CBox>

            <div class="timeline-content">
              <CFlex align="center" justify="space-between" mb="4px">
                <OmtTypography as="h2-bold">Resposta Omint</OmtTypography>
                <OmtTypography as="p2" color="var(--colors-light-primary-gray2)">
                  {{ r.DataResposta }}
                </OmtTypography>
              </CFlex>

              <OmtTypography as="p1" mt="8px">{{ r.Resposta }}</OmtTypography>
            </div>
          </div>

          <div
            v-if="hasPendency && statusCode !== 'F' && detail.pendency && detail.pendency.days > 0"
            class="cancellation-warning"
          >
            <div class="warning-header">
              <div class="warning-icon">!</div>
              <OmtTypography as="h3-bold">Motivo:</OmtTypography>
            </div>

            <OmtTypography as="p1" mt="8px">
              {{ detail.pendency.observation || "Procedimentos não descritos" }}
            </OmtTypography>

            <div class="divider"></div>

            <OmtTypography as="p2">
              <strong>Responda em até {{ detail.pendency.days }} dias</strong>
              ou a solicitação será cancelada.
            </OmtTypography>
          </div>
        </div>
      </OmtRow>

      <OmtRow v-if="hasPendency" mt="32px">
        <CBox bg="#F6F6F9" border-radius="8px" p="20px" w="100%">
          <CFlex align="flex-start">
            <CBox
              w="24px"
              h="24px"
              border-radius="50%"
              border="2px solid var(--colors-light-primary-dark-blue)"
              display="flex"
              align-items="center"
              justify-content="center"
              mr="14px"
              mt="2px"
            >
              <img :src="IconOmint" />
            </CBox>
            <CBox>
              <OmtTypography as="h3-bold" font-size="md" color="var(--colors-light-primary-dark-blue)" mb="12px">
                Para continuidade da análise, solicitamos:
              </OmtTypography>

              <ul class="pendency-list">
                <li v-for="(reason, i) in pendencyReasons" :key="'reason-' + i">
                  <OmtTypography as="p1" color="var(--colors-light-primary-gray1)">
                    {{ reason }}
                  </OmtTypography>
                </li>
              </ul>
            </CBox>
          </CFlex>
        </CBox>

        <CBox text-align="center" mb="40px" w="100%" mt="20px">
          <OmtButton
            bg="var(--colors-light-primary-dark-blue)"
            color="white"
            w="100%"
            h="50px"
            font-size="md"
            @click="modalPendencies = true"
          >
            Responder pendência
          </OmtButton>
        </CBox>
      </OmtRow>

      <PendingResponseModal :reasons="pendencyReasons" :isOpen="modalPendencies" @close="closeModal" @submit="submit" />
      <SendPendency :isOpen="openModalSuccess" :protocol="protocol" @close="closeModalSendPendency" />

      <Footer />
    </OmtGrid>
  </CBox>
</template>

<script>
import Footer from "@/components/Molecules/Footer";
import ImagePreviewer from "@/components/Molecules/ImagePreviewer";
import TextTile from "@/components/Molecules/TextTile";
import StatusTile from "@/components/Organisms/Requests/StatusTile.vue";
import PendingResponseModal from "@/components/Organisms/Sac/PendingResponseModal.vue";
import SendPendency from "@/components/Organisms/Sac/SendPendency.vue";
import { mapActions } from "vuex";
import { isMobile } from "@/utils/utils";

export default {
  name: "DetailProgramasSaude",
  components: { TextTile, StatusTile, Footer, PendingResponseModal, SendPendency, ImagePreviewer },
  data() {
    return {
      detail: {},
      modalPendencies: false,
      openModalSuccess: false,
      sending: false,
      pictures: []
    };
  },
  computed: {
    protocol() {
      return this.$route.params.protocol || "";
    },

    assunto() {
      const d = this.detail || {};
      return d.TipoSolicitacao || "";
    },

    dataSolicitacao() {
      const d = this.detail || {};
      return d.DtSolicitacao || "";
    },

    beneficiario() {
      const d = this.detail || {};
      return d.DsUtilizacao || "";
    },

    codigoBeneficiario() {
      const d = this.detail || {};
      return d.CdUtilizacao || "";
    },

    statusLabel() {
      const d = this.detail || {};
      return d.DsSituacao || "";
    },

    statusCode() {
      const d = this.detail || {};
      return d.CdSituacao || "";
    },

    statusColor() {
      const code = this.statusCode || "";
      switch (code) {
        case "F":
          return "var(--colors-light-support-success)";
        case "P":
          return "var(--colors-light-support-warning)";
        case "T":
          return "var(--colors-light-primary-gray2)";
        default:
          return "var(--colors-light-primary-dark-blue)";
      }
    },

    hasPendency() {
      const d = this.detail || {};
      const p = d.Pendencia || d.Pendencias || d.pendency || null;
      if (!p) return false;

      if (d.Pendencia) {
        const pend = d.Pendencia;
        return (Array.isArray(pend.Motivos) && pend.Motivos.length > 0) || !!pend.Observacao;
      }

      if (Array.isArray(d.Pendencias)) {
        return d.Pendencias.length > 0;
      }

      return Boolean(p);
    },

    pendencyReasons() {
      const d = this.detail || {};
      if (d.Pendencia && Array.isArray(d.Pendencia.Motivos)) return d.Pendencia.Motivos;
      if (Array.isArray(d.Pendencias)) return d.Pendencias.map(p => p.Ocorrencia || p.Observacao || p);
      if (d.Pendencia && d.Pendencia.Observacao) return [d.Pendencia.Observacao];
      if (d.pendency && Array.isArray(d.pendency.reasons)) return d.pendency.reasons;
      return [];
    },

    IconOmint() {
      return process.env.VUE_APP_BASE_URL + "images/Group3305.png";
    },

    requestDescription() {
      const d = this.detail || {};
      const fields = [d.Descricao, d.description, d.TipoSolicitacao, d.title];
      for (const f of fields) {
        if (f !== null && f !== undefined) {
          const text = String(f).trim();
          if (text.length > 0) return text;
        }
      }
      return "Sem descrição informada";
    },

    pictures() {
      const d = this.detail || {};
      if (Array.isArray(d.pictures) && d.pictures.length) return d.pictures;
      if (Array.isArray(d.Pictures) && d.Pictures.length) return d.Pictures;
      return [];
    },

    hasResponse() {
      const d = this.detail || {};
      const raw = d.doc?.resp || d.resp || d.Respostas;
      if (!raw) return [];
      const arr = Array.isArray(raw) ? raw : [raw];
      return arr.filter(r => r?.Resposta && r.Resposta.trim().length > 0);
    },

    isAnalyzingStatus() {
      return this.statusLabel === "Em análise" || (this.detail && this.detail.DsSituacao === "Em análise");
    },

    isMobile() {
      return isMobile();
    }
  },
  methods: {
    ...mapActions("programasSaude", ["fetchDetalheProtocolo", "enviarRetornoPendencia"]),

    async getDetail() {
      const response = await this.fetchDetalheProtocolo({ protocolo: this.protocol });
      if (!response) {
        this.$router.replace("/programas-saude");
        return;
      }
      this.detail = response.Data ? response.Data : response;
      if (!this.detail) this.detail = {};
      if (this.detail.pictures && Array.isArray(this.detail.pictures)) {
        this.pictures = this.detail.pictures;
      }
    },

    closeModal() {
      this.modalPendencies = false;
    },

    closeModalSendPendency() {
      this.openModalSuccess = false;
    },
    _filesFromPictures(pictures) {
      if (!Array.isArray(pictures)) return [];
      return pictures.map(p => p.file || p).filter(f => f instanceof File);
    },

    async submit({ pictures, obs }) {
      if (!this.hasPendency || this.sending) return;

      const arquivos = (pictures || [])
        .map(p => p.file || p)
        .filter(f => f instanceof File)
        .slice(0, 20);

      if (!obs?.trim() && arquivos.length === 0) {
        this.$toast({
          description: "Inclua uma observação ou pelo menos um anexo para responder à pendência.",
          status: "warning",
          duration: 7000,
          position: "top"
        });
        return;
      }

      this.sending = true;
      try {
        this.$root.$emit("show-loading");
        const resp = await this.enviarRetornoPendencia({
          protocolo: this.protocol,
          observacao: obs?.slice(0, 350) || "",
          arquivos
        });

        if (resp && (resp.Data || resp === true)) {
          this.modalPendencies = false;
          this.openModalSuccess = true;

          await this.getDetail();
        } else {
          await this.$toast({
            description: "Não foi possível registrar o atendimento. Serviço temporariamente indisponível.",
            status: "error",
            duration: 10000,
            position: "top"
          });
        }
      } catch (err) {
        console.error(err);
        await this.$toast({
          description: "Não foi possível registrar o atendimento. Serviço temporariamente indisponível.",
          status: "error",
          duration: 10000,
          position: "top"
        });
      } finally {
        this.$root.$emit("hide-loading");
        this.sending = false;
      }
    }
  },

  async mounted() {
    try {
      this.$root.$emit("show-loading");
      await this.getDetail();
    } catch (error) {
      console.error(error);
    } finally {
      this.$root.$emit("hide-loading");
    }
  }
};
</script>

<style scoped>
.info-grid {
  display: grid;
  grid-template-columns: 1fr;
  row-gap: 16px;
}
@media (min-width: 768px) {
  .info-grid {
    grid-template-columns: repeat(2, 1fr);
    column-gap: 120px;
  }
}

.pendency-list {
  list-style-type: decimal;
  padding-left: 20px;
  margin: 0;
  line-height: 1.5;
}
.pendency-list li {
  margin-bottom: 6px;
}

.timeline-block {
  position: relative;
}
.timeline-container {
  position: relative;
  padding-left: 26px;
}
.timeline-container::before {
  content: "";
  position: absolute;
  left: 24px;
  height: 90px;
  top: 0;
  bottom: 0;
  width: 2px;
  border-left: 2px dashed var(--colors-light-secondary-divider);
  z-index: 1;
}
.timeline-item {
  position: relative;
  margin-bottom: 24px;
  display: flex;
  align-items: flex-start;
}
.timeline-icon {
  position: absolute;
  left: -12px;
  top: 0;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2;
}
.timeline-content {
  width: 100%;
  display: flex;
  padding-left: 32px;
  flex-direction: column;
}

.image-grid {
  width: 32px;
  height: 32px;
  border-radius: 4px;
  overflow: hidden;
}

.image-grid > * img {
  width: 32px;
  height: 32px !important;
  object-fit: cover;
  object-position: center;
  image-rendering: auto;
}

.cancellation-warning {
  margin-top: 20px;
  padding: 16px;
  border-radius: 8px;
  background: #fafafb;
  border: 1px solid #e1e1e6;
}

.warning-header {
  display: flex;
  align-items: center;
  margin-bottom: 8px;
}

.warning-icon {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  border: 2px solid #6b6b76;
  color: #6b6b76;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  margin-right: 8px;
}

.divider {
  margin: 12px 0;
  height: 1px;
  background: #e1e1e6;
}
</style>
